export default [
  {
    path: '/conference',
    name: '会议详情',
    component: () => import(/* webpackChunkName: "conference" */ '../views/Conference/index.vue')
  },
  {
    path: '/conference/videoList',
    name: '关联录屏',
    component: () => import(/* webpackChunkName: "videoList" */ '../views/Conference/videoList/videoList.vue')
  },
  {
    path: '/conference/go',
    name: '前往会议',
    component: () => import(/* webpackChunkName: "videoList" */ '../views/Conference/jumpMiddleware/index.vue')
  },
  
]